import { render } from "./skip-forward.vue?vue&type=template&id=403b6f3e"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/skip-forward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "403b6f3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('403b6f3e', __exports__)) {
    api.reload('403b6f3e', __exports__)
  }
  
  module.hot.accept("./skip-forward.vue?vue&type=template&id=403b6f3e", () => {
    api.rerender('403b6f3e', render)
  })

}


export default __exports__